import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconTwitter = props => (
  <SvgIcon {...props} viewBox="0 0 20 20">
    <path d="m18 0h-16c-1.1 0-2 0.9-2 2v16c0 1.1 0.9 2 2 2h16c1.1 0 2-0.9 2-2v-16c0-1.1-0.9-2-2-2zm-2.3 7.3c-0.1 4.6-3 7.8-7.4 8-1.8 0.1-3.1-0.5-4.3-1.2 1.3 0.2 3-0.3 3.9-1.1-1.3-0.1-2.1-0.8-2.5-1.9 0.4 0.1 0.8 0 1.1 0-1.2-0.4-2-1.1-2.1-2.7 0.3 0.2 0.7 0.3 1.1 0.3-0.9-0.5-1.5-2.4-0.8-3.6 1.3 1.4 2.9 2.6 5.5 2.8-0.7-2.8 3.1-4.3 4.6-2.4 0.7-0.1 1.2-0.4 1.7-0.6-0.2 0.7-0.6 1.1-1.1 1.5 0.5-0.1 1-0.2 1.4-0.4-0.1 0.5-0.6 0.9-1.1 1.3z" />
  </SvgIcon>
);

export default IconTwitter;



// WEBPACK FOOTER //
// ./src/components/icons/IconTwitter.js